import { TslDebug } from '@/components/TslDebug';
import TslDebugArea from '@/components/TslDebugArea';
import WebGpuCanvas from '@/components/WebGpuCanvas';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import * as React from 'react';
import { Fn, positionLocal, length, abs, smoothstep, vec2 } from 'three/tsl';

export type Props = {};

const Circle = Fn(([p, r, t]: [p: typeof positionLocal, radius: number, thickness: number]) => {
  const distance = length(p).sub(r);
  return smoothstep(t, 0.0, abs(distance));
});

function App02(props: Props) {
  const {} = props;
  const fragmentNode = React.useMemo(() => {
    const p = positionLocal;
    const radius = 0.1;
    const thickness = 0.01;
    const circleOffset = vec2(-0.33, 0.33);
    const circle = Circle(p.sub(circleOffset), radius, thickness);
    return circle;
  }, []);
  return (
    <TslDebugArea style={{ backgroundColor: 'black' }}>
      {(el) => (
        <WebGpuCanvas>
          <PerspectiveCamera
            makeDefault
            fov={53}
            aspect={el.clientWidth / el.clientHeight}
            near={0.1}
            far={10}
            position={[0, 0, 1]}
          />
          <mesh name="node-mesh">
            <planeGeometry args={[5, 5]} />
            <nodeMaterial fragmentNode={fragmentNode} />
            <TslDebug meshName={'node-mesh'} />
          </mesh>
          <gridHelper rotation={[-Math.PI / 2, 0, 0]} />
          <axesHelper />
          <OrbitControls />
        </WebGpuCanvas>
      )}
    </TslDebugArea>
  );
}

export default React.memo(App02);
